export default {
  selectLang: "Seleccionar idioma",
  footer: {
    copyright: "© 2025 TaxEcoBit. Todos los derechos reservados.",
    terms: "Términos de servicio",
    privacy: "Política de privacidad",
    help: "¿Ayuda o sugerencias?",
  },
  menu: {
    dashboard: "Panel de control",
    calculate: "Calcular",
    calculations: "Cálculos",
    pricing: "Precios",
    settings: "Configuración",
    factors: "Factores",
    reports: "Informes",
    upgrade: "Actualizar",
    usage: "Uso",
    invite: "Invitaciones",
    home: "Inicio",
    blog: "Blog",
    whitepaper: "Libro blanco",
    about: "Acerca de",
    faq: "Preguntas frecuentes",
    terms: "Términos de servicio",
    privacy: "Política de privacidad",
    tickets: "Tickets",
    billing: "Facturación",
    "billing-overview": "Resumen",
    "billing-orders": "Pedidos",
    "billing-invoices": "Facturas",
    "billing-subscription": "Suscripción",
    templates: "Plantillas",
  },
  upgradeWall: {
    successTitle: "Solicitud de prueba exitosa",
    successSubtitle: "Ha solicitado con éxito la prueba Pro gratuita de 14 días",
    quotaTitle: "Cuota de cálculo:",
    reportQuotaTitle: "Cuota de informe:",
    planComparison: "Comparación de funciones del plan",
    calculation: "Cálculo",
    report: "Informe",
    price: "Precio",
    viewPricing: "Ver precios completos",
    freeTrial: "Prueba Pro gratuita de 14 días",
    upgradeToPro: "Actualizar a Pro",
    upgradePro: "Actualizar Pro",
    contactSupport: "Contactar soporte",
    inviteRewards: "¡Obtenga más cuota a través de invitaciones!",
    inviteRewardsDesc:
      "Invite amigos a registrarse y tanto usted como sus amigos recibirán cuota adicional de cálculo",
    inviteFriends: "Invitar amigos",
    quotaExhausted: "Su cuota del plan se ha agotado",
    calculationThreshold: "Su cuota de cálculo está al {percent}% utilizada",
    reportThreshold: "Su cuota de informe está al {percent}% utilizada",
    upgradePlan: "Plan de actualización",
    free: "Gratis",
    basic: "49 €/mes",
    proPrice: "99 €/mes",
    timesPerMonth: "veces/mes",
    plan: "Plan",
    trialSuccess: "Solicitud de prueba exitosa",
  },
  ticket: {
    modal_title: "Enviar ticket",
  },
  brand: {
    what_is_taxecobit: "¿Qué es TaxEcoBit?",
    taxecobit_description:
      "TaxEcoBit es una plataforma de automatización de cumplimiento diseñada para empresas afectadas por el Mecanismo de Ajuste Fronterizo de Carbono (CBAM) de la UE. Ayudamos a importadores, fabricantes y PYME a calcular emisiones de carbono específicas de productos, generar documentos compatibles con la CBAM y reducir riesgos regulatorios.",
    taxecobit_benefits: "Con TaxEcoBit, los usuarios pueden:",
    benefit_accurate_calculations:
      "Realizar cálculos precisos de carbono utilizando factores de emisión oficiales y personalizados",
    benefit_cbam_documents: "Generar documentos compatibles con la CBAM para presentar",
    benefit_carbon_cost_tracking:
      "Monitorear el impacto del costo del carbono y optimizar la eficiencia operativa",
    benefit_api_integration:
      "Integrar flujos de trabajo de cumplimiento sin problemas con sistemas ERP y de cadena de suministro a través de API",
    taxecobit_conclusion:
      "Al reemplazar cálculos manuales en hojas de cálculo y la dependencia de consultores, TaxEcoBit permite un cumplimiento más rápido, confiable y con menores costos operativos.",
  },
  userLevel: {
    label: "Nivel de usuario",
    highest_level: "Nivel más alto",
    next_level: "Siguiente nivel: {level}",
    standard_user: "Usuario estándar",
    bronze_user: "Usuario bronce",
    silver_user: "Usuario plata",
    gold_user: "Usuario oro",
    platinum_user: "Usuario platino",
    bronze_next: "Bronce (50 cálculos)",
    silver_next: "Plata (150 cálculos)",
    gold_next: "Oro (300 cálculos)",
    platinum_next: "Platino (600 cálculos)",
    highest_level_text: "Nivel más alto alcanzado",
  },
  notification: {
    title: "Notificaciones",
    settings: "Configuración de notificaciones",
    preferences: "Preferencias de notificación",
    email_notifications: "Notificaciones por correo electrónico",
    app_notifications: "Notificaciones de aplicación",
    all: "Todas las notificaciones",
    important: "Solo notificaciones importantes",
    none: "Sin notificaciones",
    save_preferences: "Guardar preferencias de notificación",
    success_message: "Preferencias de notificación guardadas con éxito",
    error_message: "Error al guardar las preferencias de notificación",
    detail_title: "Detalles de notificación",
    mark_as_read: "Marcar como leído",
    not_found_title: "Notificación no encontrada",
    not_found_desc: "La notificación que busca no existe o ha sido eliminada.",
    search_placeholder: "Buscar por título o contenido",
    email_sent: "Correo electrónico enviado",
    in_app_only: "Solo en aplicación",
    no_notifications: "Sin notificaciones",
    total: "Total {total} notificaciones",
    fetch_failed: "Error al obtener notificaciones",
    marked_as_read: "Marcado como leído con éxito",
    mark_failed: "Error al marcar como leído",
    mark_all_read: "Marcar todo como leído",
    view_all: "Ver todo",
  },
  notFound: {
    title: "404 No encontrado",
    description: "Lo sentimos, la página que visitó no existe.",
    goHome: "Ir a la página principal",
  },
  login: {
    sign_in: "Iniciar sesión",
    sign_up: "Registrarse",
    password_rule_length: "Al menos 8 caracteres",
    password_rule_letter: "Contiene letras en inglés",
    password_rule_number: "Contiene números",
    password_rule_special: "Contiene caracteres especiales {0}",
  },
};
